common.View.create('galaxy::common.form.inputs.Datetime', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initDatetimepicker();
    },

    /**
     * Initializes the Datetimepicker.
     */
    initDatetimepicker(){

        this.element

            .find('input')
                .daterangepicker({
                    singleDatePicker: true,
                    timePicker: true,
                    timePicker24Hour: true,
                    format: 'DD-MM-YYYY hh:mm',
                    locale: require('../../daterangepicker').locale,
                    autoUpdateInput: false,
                }).on('apply.daterangepicker', (ev, picker) => {
                    // Set date
                    $(ev.currentTarget).val(picker.startDate.format('DD-MM-YYYY hh:mm'));

                    // Loop day month year
                    let loopItems = {'DD': 'day', 'MM': 'month', 'YYYY': 'year'};
                    for(let [dateFormat, datePart] of Object.entries(loopItems)) {
                        // Is date part only
                        if( this.element.find('input').data(datePart + 'only') ) {
                            $(ev.currentTarget).val(picker.startDate.format(dateFormat));
                        }
                    }
                });

    },

});
